<template>
  <v-app class="main-app">
    <h1 @click.stop="salir">SiGeMed</h1>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  methods: {
    salir() {
      window.location.href = "https://www.sigemed.com.ar";
    },
  },
};
</script>
